import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import {
  WithStyles,
  Typography,
  MenuItem,
  Grid,
  TextField,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import contentSubtypeActions from "../../mylibrary/actions/contentSubtypeActions";
import { ContentSubType } from "../../test-template/types/ContentSubTypeBody";

import { bindActionCreators } from "redux";
import { MyPATTextField, MyPATSelect } from "../../common";
import { TestDetailStyle } from "../styles/TestDetailStyle";
import contentService from "../services/contentRequestServices";
import CourseData from "../../mylibrary/types/CourseData";
import classNames from "classnames";
import { fetchSubjects, addSubject } from "../actions/contentRequestActions";
import { ContentRequest } from "../types/ContentRequest";
import { Subject } from "../../course/modals/CourseBasicInfo";
import { Subject as CRSubject } from "../types/ContentRequest";
import MyPATBaseSection, {
  SectionFocusedContext,
  SectionFocusedContextValue,
} from "../../common/MyPATBaseSection";

interface AddTestDetailProps extends WithStyles<typeof TestDetailStyle> {
  classes: any;
  fetchSubjects: Function;
  subjects: any[];
  contentsubType: ContentSubType[];

  contentSubtypeList: Function;
  addSubject: Function;
  removeSubject: Function;
  selectedSubjects: any[];
  transferToParent: (requestData: ContentRequest) => void;
  requestData: ContentRequest;
  isSectionDisabled?: boolean;
}

interface AddTestDetailStates {
  isOpenAddTestDetailDialog: boolean;
  type: any;
  name: string;
  courses: CourseData[];
  selectedCourseId: string;
}

class AddTestDetail extends Component<AddTestDetailProps, AddTestDetailStates> {
  constructor(props: AddTestDetailProps) {
    super(props);
    const name = _.get(
      props.requestData.requestInfo,
      "details.testDetails.name",
      ""
    );
    const selectedCourseId = _.get(
      props.requestData.requestInfo,
      "details.courseTypes[0].id",
      "none"
    );
    const selectedtype = _.get(
      props.requestData.requestInfo,
      "details.testDetails.type",
      "none"
    );
    this.state = {
      name,
      isOpenAddTestDetailDialog: true,
      courses: [],
      selectedCourseId: selectedCourseId,
      type: selectedtype || "none",
    };
    this.handleSubjectChange = this.handleSubjectChange.bind(this);
    this.onChange = _.debounce(this.onChange, 200);
  }

  onChange = () => {
    const { type, name, selectedCourseId, courses } = this.state;
    const { requestData, transferToParent } = this.props;
    const newRequestData = { ...requestData };
    if (newRequestData.requestInfo.details.testDetails) {
      const newRequestInfo = { ...newRequestData.requestInfo };
      const newDetails = { ...newRequestInfo.details };
      if (newDetails.testDetails) {
        const newTestDetails = { ...newDetails.testDetails };
        newTestDetails.name = name;
        newTestDetails.type = type;

        newDetails.testDetails = newTestDetails;
        newRequestInfo.details = newDetails;
        newRequestData.requestInfo = newRequestInfo;
      }
    } else {
      newRequestData.requestInfo.details.testDetails = {
        name,
        type,
        contentRequestItemsId: null,
        authors: [],
      };
    }
    const selectedCourse = courses.find(({ _id }) => _id === selectedCourseId);
    if (selectedCourse) {
      newRequestData.requestInfo.details.courseTypes = [
        { name: selectedCourse.name, id: selectedCourseId },
      ];
    }
    transferToParent(newRequestData);
  };

  componentDidMount() {
    const { selectedCourseId } = this.state;
    const { requestData } = this.props;
    _.isEmpty(this.props.contentsubType) && this.props.contentSubtypeList();

    contentService
      .goalList()
      .then((courses: CourseData[]) => this.setState({ courses }));

    const initiallySelectedSubjectIds = requestData.requestInfo.details.subjects.map(
      ({ id }) => id
    );
    this.props.addSubject(initiallySelectedSubjectIds);

    if (selectedCourseId && selectedCourseId !== "none") {
      this.props.fetchSubjects(selectedCourseId);
    }
  }
  handleNameChange(event: any) {
    this.setState({ name: event.target.value }, () => this.onChange());
  }

  handleGoalChange(event: any) {
    this.props.fetchSubjects(event.target.value);
    const selectedSubjectIds: any[] = [];
    this.props.addSubject(selectedSubjectIds);
    this.setState({ selectedCourseId: event.target.value }, () =>
      this.onChange()
    );
  }
  handleTestChange(event: any) {
    this.setState(
      {
        type: event.target.value,
      },
      () => this.onChange()
    );
  }
  handleSubjectChange(event: any) {
    const values = event.target.value;
    let selectedSubjectIds = values;
    if (values.typeof == "string") {
      selectedSubjectIds = [values];
    }
    this.props.addSubject(selectedSubjectIds);
    this.propagateSubjectsChange(selectedSubjectIds);
  }
  propagateSubjectsChange = (selectedSubjectIds: string[]) => {
    const { subjects, requestData, transferToParent } = this.props;

    const selectedSubjects = subjects.filter(({ _id }) =>
      selectedSubjectIds.includes(_id)
    );

    const subjectData = selectedSubjects.map(({ name, _id }) => {
      // Check Subject data already exits
      const foundSubject = requestData.requestInfo.details.subjects.find(
        (subject) => {
          return subject.id === _id;
        }
      );
      // If it is return that
      if (foundSubject) {
        return foundSubject;
      }
      // Else ccreate generic
      return {
        name,
        id: _id,
        questions: [],
      };
    });
    const newRequestData = { ...requestData };
    newRequestData.requestInfo.details.subjects = subjectData;
    transferToParent(newRequestData);
  };

  renderer = () => {
    const { subjects, selectedSubjects } = this.props;
    return subjects
      .reduce((acc: string[], { _id, name }) => {
        if (selectedSubjects.includes(_id)) {
          acc.push(name);
        }
        return acc;
      }, [])
      .join(", ");
  };
  render() {
    const {
      classes,
      contentsubType,
      subjects,
      selectedSubjects,
      isSectionDisabled,
    } = this.props;
    const { courses, name, selectedCourseId, type } = this.state;

    // TODO - Confirm from product how to handle same type
    const contentSubTypeSet = new Set();
    const contentSubTypeToShow = contentsubType.filter((type) => {
      if (contentSubTypeSet.has(type.code)) {
        return false;
      }
      contentSubTypeSet.add(type.code);
      return true;
    });

    return (
      <MyPATBaseSection sectionId="testDetails">
        <Grid
          className={classNames(
            classes.whiteCard,
            isSectionDisabled && classes.disabledSection
          )}
        >
          <Typography className={classes.mainHeading}>Test Details</Typography>
          <Grid container justify="flex-start" spacing={24}>
            <Grid
              item
              xs={12}
              className={[classes.customInput, classes.whitecardContainer].join(
                " "
              )}
            >
              <MyPATTextField
                placeholder="Enter Test name"
                value={name}
                name="name"
                onChange={this.handleNameChange.bind(this)}
                required
                fullWidthControl
              />
            </Grid>

            <Grid item xs={4}>
              <div className={classes.customSelect}>
                <Typography className={classes.inputLabel}>
                  Test Type
                </Typography>
                <SectionFocusedContext.Consumer>
                  {({ setSectionFocus }: SectionFocusedContextValue) => (
                    <TextField
                      select
                      className={classNames(classes.margin, classes.textField)}
                      name="type"
                      value={type}
                      onChange={this.handleTestChange.bind(this)}
                      onFocus={() => setSectionFocus(true)}
                      onBlur={() => setSectionFocus(false)}
                      defaultValue={"none"}
                      required
                    >
                      <MenuItem value={"none"} key={-1} disabled>
                        <Typography
                          variant="body2"
                          align="left"
                          inline
                          className={classes.greyText}
                        >
                          Select Test Type
                        </Typography>
                      </MenuItem>
                      {_.map(contentSubTypeToShow, (type, index) => (
                        <MenuItem value={type.code} key={type._id}>
                          {type.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </SectionFocusedContext.Consumer>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.customSelect}>
                <Typography className={classes.inputLabel}>Goal</Typography>
                <SectionFocusedContext.Consumer>
                  {({ setSectionFocus }: SectionFocusedContextValue) => (
                    <TextField
                      select
                      className={classNames(classes.margin, classes.textField)}
                      value={selectedCourseId}
                      onChange={this.handleGoalChange.bind(this)}
                      onFocus={() => setSectionFocus(true)}
                      onBlur={() => setSectionFocus(false)}
                      name="goalLevel"
                      required
                      defaultValue={"none"}
                    >
                      <MenuItem value={"none"} key={-1} disabled>
                        <Typography
                          variant="body2"
                          align="left"
                          inline
                          className={classes.greyText}
                        >
                          Select Goal for the test
                        </Typography>
                      </MenuItem>
                      {_.map(courses, (course, index) => (
                        <MenuItem
                          value={course._id}
                          data-optionname={course.name}
                          key={index}
                        >
                          {course.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </SectionFocusedContext.Consumer>
              </div>
            </Grid>

            <Grid item xs={4}>
              <div className={classes.customSelect}>
                <Typography className={classes.inputLabel}>Subjects</Typography>
                {/* <TextField
                                select
                                className={classNames(classes.margin, classes.textField)}
                                value={1}
                                >
                                      <MenuItem value={1}>
                                    Add Subjects for your Test
                                </MenuItem>
                                {_.map(subjects, (course, index) => (
                    <MenuItem
                      value={course._id}
                      data-optionname={course.name}
                      key={index}
                    >
                      {course.name}
                                    </MenuItem>
                  ))}
                            </TextField> */}
                <MyPATSelect
                  multiple={true}
                  isNative={false}
                  fullWidthControl
                  required
                  onChange={this.handleSubjectChange}
                  inputId="subject"
                  name="subjects"
                  value={selectedSubjects}
                  customRenderFunc={this.renderer}
                  displayEmpty
                  placeholder={
                    <Typography
                      variant="body2"
                      align="left"
                      inline
                      className={classes.greyText}
                    >
                      Select Subject
                    </Typography>
                  }
                >
                  {(subjects || []).map(({ _id, name }) => (
                    <MenuItem key={_id} value={_id}>
                      <Checkbox
                        color="primary"
                        checked={selectedSubjects.includes(_id)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </MyPATSelect>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </MyPATBaseSection>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    subjects: state.contentRequestReducer.contentRequestCreateReducer.subjects,
    selectedSubjects:
      state.contentRequestReducer.contentRequestCreateReducer.selectedSubjects,
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      contentSubtypeList: contentSubtypeActions.list,
      fetchSubjects,
      addSubject,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(TestDetailStyle)(AddTestDetail));
